export const AIMO_PARKING_REGEX_RULES = {
  FULL_WIDTH_CHARACTER: {
    REGEX: /^[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]+$/,
  },
  NAME_CHARACTER: {
    REGEX: /^[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAFa-zA-Z\s]+$/,
  },
  KATAKANA: {
    REGEX: /^[\u30A0-\u30FF]+$/,
  },
};
